import { render, staticRenderFns } from "./examManageLeft.vue?vue&type=template&id=3745b636&scoped=true&"
import script from "./examManageLeft.vue?vue&type=script&lang=js&"
export * from "./examManageLeft.vue?vue&type=script&lang=js&"
import style0 from "./examManageLeft.vue?vue&type=style&index=0&id=3745b636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3745b636",
  null
  
)

export default component.exports